import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { ColumnConfigurationModel } from "@/Common/Models/UI/Tables/ColumnConfigurationModel";
import { DateHelper } from "./DateHelper";

class ArrayHelper {
    public static FirstOrDefault(array: any[]): any {
        if (array != null && array.length > 0)
            return array[0];

        return null;
    }

    public static GroupBy<T>(array: T[], functionToReturnGroupByProperty: (item: T) => any): T[][] {
        const groups = {};
        array.forEach(o => {
            const group = JSON.stringify(functionToReturnGroupByProperty(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });

        return Object
            .keys(groups)
            .map(group => groups[group]);
    }

    public static GetArrayOfUniques(array: any[]): any[] {
        var result: any[] = [];

        result = array
            .reduce(
                (prev: any[], current: any) => {
                    if (prev.indexOf(current) < 0)
                        prev.push(current);
                    return prev;
                },
                []
            );

        return result;
    }

    public static MoveElementUp(array: ColumnConfigurationModel[], movingColumn: any): any[] {
        var idx = array.indexOf(movingColumn);
        var idxNext = this.PreviousMovableIndex(array, idx);
        if (idxNext < 0)
            return array;

        var newArray = [];

        for (var i = 0; i < array.length; i++) {
            var insertItem = null;
            if (i == idx) {
                insertItem = array[idxNext];
            }
            else if (i == idxNext) {
                insertItem = array[idx];
            }
            else {
                insertItem = array[i];
            }

            newArray.push(insertItem);
        }

        return newArray;
    }

    public static MoveElementDown(array: ColumnConfigurationModel[], movingColumn: any): any[] {
        var idx = array.indexOf(movingColumn);
        var idxNext = this.NextMovableIndex(array, idx);

        if (idxNext < 0)
            return array;

        var newArray = [];

        for (var i = 0; i < array.length; i++) {
            var insertItem = null;
            if (i == idx) {
                insertItem = array[idxNext];
            }
            else if (i == idxNext) {
                insertItem = array[idx];
            }
            else {
                insertItem = array[i];
            }
            newArray.push(insertItem);
        }

        return newArray;
    }

    public static Find(array: any[], searchFunc: (any) => boolean): any {
        var result = array.filter(x => searchFunc(x));
        if (result && result.length >= 0)
            return result[0];
        else
            return null;
    }

    public static SortDynamic<T>(array: T[], property: string, isDescending: boolean = false, caseInsensitive: boolean = true, isDate: boolean = false): T[] {
        var isStringArray = false;
        if (!isDate && caseInsensitive && array.length > 0) {
            isStringArray = (array[0][property] != null && array[0][property] != undefined && typeof (array[0][property]) == "string");
        }

        let undefinedOrNullElements: T[] = array.filter(a => a[property] == null && a[property] == undefined);

        function predicateBy(prop: string): (a: T, b: T) => number {
            return function(a: T, b: T): number {
                var compA = isDate ? DateHelper.formatIsoFull(a[prop]) : a[prop];
                var compB = isDate ? DateHelper.formatIsoFull(b[prop]) : b[prop];

                if (a == null || a == undefined) {
                    if (!isDescending)
                        return 1;
                    else
                        return -1;
                }

                if (b == null || b == undefined) {
                    if (!isDescending)
                        return -1;
                    else
                        return 1;
                }

                if (isStringArray && caseInsensitive) {
                    compA = (compA != null && compA != undefined) ? compA.toLowerCase() : "";
                    compB = (compB != null && compB != undefined) ? compB.toLowerCase() : "";
                }

                if (isStringArray) {
                    const compAtoNumber = Number(compA);
                    const compBtoNumber = Number(compB);

                    const isCompANumber = !isNaN(compAtoNumber);
                    const isCompBNumber = !isNaN(compBtoNumber);

                    if (isCompANumber && isCompBNumber) {
                        compA = compAtoNumber;
                        compB = compBtoNumber;
                    }
                }

                if (compA > compB) {
                    if (!isDescending)
                        return 1;
                    else
                        return -1;
                }
                else if (compA < compB) {
                    if (!isDescending)
                        return -1;
                    else
                        return 1;
                }
                return 0;
            };
        }

        let sorted: T[] = array.filter(a => a[property] != null && a[property] != undefined).sort(predicateBy(property));

        if (isDescending) {
            undefinedOrNullElements.push.apply(undefinedOrNullElements, sorted);
            return undefinedOrNullElements;
        }
        else {
            sorted.push.apply(sorted, undefinedOrNullElements);
            return sorted;
        }
    }

    public static Unique(array: any[]): any[] {
        var prims = { "boolean": {}, "number": {}, "string": {} }, objs = [];

        if (array == null)
            return array;

        return array.filter(x => {
            var type = typeof x;
            var result: boolean;

            if (type in prims)
                result = prims[type].hasOwnProperty(x) ? false : (prims[type][x] = true);
            else {
                if (objs.indexOf(x) >= 0) result = false;
                else {
                    objs.push(x);
                    result = true;
                }
            }

            return result;
        });
    }

    private static PreviousMovableIndex(array: ColumnConfigurationModel[], index: number): number {
        if (index <= 0)
            return -1;

        var found = false;
        while (index > 0) {
            index--;
            if (!array[index].IsFixedInPlace && !array[index].IsHidden) {
                found = true;
                break;
            }
        }
        if (!found)
            return -1;
        else
            return index;
    }

    private static NextMovableIndex(array: ColumnConfigurationModel[], index: number): number {
        if (index >= array.length)
            return -1;

        var found = false;
        while (index < array.length - 1) {
            index++;
            if (!array[index].IsFixedInPlace && !array[index].IsHidden) {
                found = true;
                break;
            }
        }
        if (found == false)
            return -1;
        else
            return index;
    }

    public static AreEmployeeUIModelEquallyChecked(a: EmployeeUIModel[], b: EmployeeUIModel[]): boolean {
        if (a.length !== b.length)
            return false;

        var pass = true;
        for (var i = 0; i < a.length; i++) {
            if (a[i].Checked !== b[i].Checked) {
                pass = false;
                break;
            }
        }

        return pass;
    }
}

export { ArrayHelper };
